import {AxiosError} from 'axios';
import {GET_EXAM_SERIES_QUERY_KEY} from '../../constants/queryKeys';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GET_EXAM_SERIES_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export enum ExamSeries {
  MIDYEAR = 'MID-YEAR',
  YEAREND = 'YEAR-END',
}

export interface ExamSeriesModel {
  code: string;
  description: ExamSeries;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetExamSeries = ({onSuccess, onError}: Input = {}) => {
  const getExamSeries = async () => {
    const res = await axiosClient.get<ExamSeriesModel[]>(GET_EXAM_SERIES_URL);
    return res.data;
  };

  return useCustomQuery(GET_EXAM_SERIES_QUERY_KEY, getExamSeries, {
    onSuccess,
    onError,
  });
};
